"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import { useMediaGallery } from "..";
interface GalleryMediaCounterProps {
  className?: string;
  showMediaName?: boolean;
}
export function GalleryMediaCounter(t0) {
  const $ = _c(9);
  const {
    className,
    showMediaName: t1
  } = t0;
  const showMediaName = t1 === undefined ? true : t1;
  const {
    currentIndex,
    media
  } = useMediaGallery();
  const currentMedia = media[currentIndex];
  if (media.length <= 1) {
    return null;
  }
  let t2;
  if ($[0] !== className) {
    t2 = cn("absolute top-3 left-3 z-10 flex items-center h-6", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = currentIndex + 1;
  const t4 = showMediaName && currentMedia?.name && ` • ${currentMedia.name}`;
  let t5;
  if ($[2] !== media.length || $[3] !== t3 || $[4] !== t4) {
    t5 = <div className="bg-black/50 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-full">{t3} / {media.length}{t4}</div>;
    $[2] = media.length;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t5) {
    t6 = <div className={t2}>{t5}</div>;
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}